import { reactive, computed } from "vue";
import {
  PublicClientApplication,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { msalConfig, loginScopes } from "../config/msal";


const msalInstance = new PublicClientApplication(msalConfig);

const state = reactive({
  account: msalInstance.getAllAccounts()[0] ?? null,
});

if (state.account) msalInstance.setActiveAccount(state.account);

export const account = computed(() => state.account);

export function isAuthenticated() {
  return !!state.account;
}

export async function signIn() {
  await msalInstance.loginPopup({ scopes: loginScopes });
  state.account = msalInstance.getAllAccounts()[0] ?? null;
  if (state.account) msalInstance.setActiveAccount(state.account);
}

export async function signOut() {
  await msalInstance.logoutPopup({});
  state.account = null;
}

export function getAccessToken() {
  const pending = acquireToken()
  return pending;
}

async function acquireToken() {
  const activeAccount = state.account ?? msalInstance.getAllAccounts()[0] ?? null;
  if (!activeAccount) {
    throw new Error("Not signed in — cannot acquire an access token.");
  }

  const request = { scopes: loginScopes, account: activeAccount };

  try {
    const result = await msalInstance.acquireTokenSilent(request);
    return result.accessToken;
  } catch (error) {
    //Silent Renewal Failed
    if (error instanceof InteractionRequiredAuthError) {
      const result = await msalInstance.acquireTokenPopup(request);
      if (result.account) {
        state.account = result.account;
        msalInstance.setActiveAccount(result.account);
      }
      return result.accessToken;
    }
    throw error;
  }
}
